// extracted by mini-css-extract-plugin
module.exports = {"errorText":"InvoicesGeneratePopup_errorText_27QrE","option":"InvoicesGeneratePopup_option_x10E5","accountLabel":"InvoicesGeneratePopup_accountLabel_3Fkm2"};